import { Props_SnippetContent } from './Content.props'
import { Legacy_CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const SnippetContent = (props: Props_SnippetContent) => {
    const { heading, repeatable_link, paragraph } = props
    
    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-content__heading--${heading.visibility.value}` : ''

    return (
        <section className="snippet-content">
            <div className="snippet-content__container">
                <h2 className={`snippet-content__heading ${classHeadingVisibility}`}>{heading?.content?.value}</h2>
                <div className="snippet-content__content">
                {paragraph.text.value && Legacy_CompileMarkdown(paragraph?.text?.value)}
                </div>
                <div className="snippet-content__link-container">
                    {repeatable_link.map((link, index) => {
                        const { linkHref, linkText, openInNewTab } = link;
                        
                        return (
                            linkHref?.value && linkText?.value && (
                                <a key={`snippet-content__link-${index+1}`}
                                    className="snippet-content__link"
                                    href={linkHref.value}
                                    target={openInNewTab?.value === 'true' ? '_blank' : '_self'}
                                    rel={openInNewTab?.value === 'true' ? 'noopener noreferrer' : undefined}
                                >
                                    {linkText?.value}
                                </a>
                            )
                        )
                    })}
                </div>
            </div>
        </section>
    )}

export default SnippetContent
